import { render, staticRenderFns } from "./SvgUse.vue?vue&type=template&id=0ca3a56c"
import script from "./SvgUse.vue?vue&type=script&lang=js"
export * from "./SvgUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports